import { Tool } from "@/types";
import { apiClient } from "./api";

export const toolsApi = {
  list: () =>
    apiClient
      .get<{ tools: Tool[] }>("/eval/api/tools")
      .then((data) => data.tools || []),
};
